<template>
    <div class="account-page">

        <div class="account-form-wrapper mb-2">

            <h1 class="display-heading">{{ isStaffLogin ? 'Clinic Login' : isVaccinationCentreLogin ? 'Vaccination Centre Login' : 'User Login' }}</h1>

            <form @submit.prevent="submitLogin">
                <template v-if="isStaffLogin">
                    <div class="form-group">
                        <label>Login As</label>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="clinicStaffLogin" id="loginAsDoctorOrNurse" value="loginAsDoctorOrNurse" v-model="radioClinicStaffLogin">
                            <label class="form-check-label" for="loginAsDoctorOrNurse">
                                Doctor or Nurse
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="clinicStaffLogin" id="loginAsClinicAdmin" value="loginAsClinicAdmin" v-model="radioClinicStaffLogin">
                            <label class="form-check-label" for="loginAsClinicAdmin">
                                Clinic Admin
                            </label>
                        </div>
                    </div>
                </template>
                <div class="form-group required">
                    <label>
                        <template v-if="isStaffLogin">Clinic Registered Email Address</template>
                        <template v-else>Email Address</template>
                    </label>

                    <input type="text" name="email" ref="email" data-vv-validate-on="blur"
                        placeholder="Enter your email address" v-model.trim="form.emailAddress" v-validate="'required|email'"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('email')
                        }">

                    <div v-show="validationErrors.has('email')" class="invalid-feedback">
                        {{ validationErrors.first('email') }}
                    </div>
                </div>

                <div class="form-group required" v-if="isStaffLogin && isClinicDoctorOrNurseLogin">
                    <label>Username</label>

                    <input type="text" name="username" ref="username" data-vv-validate-on="blur"
                        placeholder="Enter your username" v-model="form.username" v-validate="'required'"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('username')
                        }">

                    <div v-show="validationErrors.has('username')" class="invalid-feedback">
                        {{ validationErrors.first('username') }}
                    </div>
                </div>

                <div class="form-group required">
                    <label>Password</label>

                    <input type="password" name="password" data-vv-validate-on="blur" placeholder="Enter your password"
                        v-model="form.password" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('password')
                        }">

                    <div v-show="validationErrors.has('password')" class="invalid-feedback">
                        {{ validationErrors.first('password') }}
                    </div>
                </div>

                <div class="form-group">
                    <div class="mb-2 small text-danger">
                        * Required fields.
                    </div>
                    <!-- <div class="mb-2">
                        <router-link to="forgot-password">Forgot your password?</router-link>
                    </div> -->
                    <!-- <div>
                        <router-link to="register">Register a new account</router-link>
                    </div> -->
                </div>

                <div class="form-group">
                    <div :class="{
                        'text-danger': loginErrorCritical
                    }" v-show="loginError" v-html="loginErrorMessage">
                    </div>
                    <div v-if="loginError && userEmailNeedsVerification" class="mt-3">
                        <p>
                            If you didn't receive any activation email, please <a href="javascript:void(0);" @click="requestNewVerificationEmail">click here</a> to request for a new activation email.
                        </p>
                    </div>
                </div>

                <div class="form-group">
                    <button type="submit" class="btn btn-primary btn-primary-insv btn-block"
                        :disabled="isSubmitting">
                        Login
                    </button>
                </div>
            </form>

            <template v-if="!isVaccinationCentreLogin">
                <div class="hr-label">
                    or
                </div>

                <template v-if="!isStaffLogin">
                    <router-link :to="{'name': 'register-landing'}" class="btn btn-primary btn-block mb-3">Register a New Account</router-link>
                </template>

                <button v-if="isStaffLogin" @click="changeToUserLogin" class="btn btn-success btn-block mb-3">{{ 'Switch to User Login' }}</button>
                <button v-if="!isStaffLogin" @click="changeToClinicLogin" class="btn btn-success btn-block mb-3">{{ 'Switch To Clinic Login' }}</button>
                <router-link :to="{'name': 'forgot-password'}">Forgot Your Password?</router-link>
                <!-- <button class="btn btn-primary btn-primary-insv btn-block">Login</button> -->
            </template>

            <div class="mt-5">
                <div class="d-flex">
                    <div>
                        <a href="https://play.google.com/store/apps/details?id=com.dsavvytech.healthsavvy" target="_blank">
                            <img src="/static/images/download/playstore_badge.png" style="width: 130px;" />
                        </a>
                    </div>
                    <div class="ml-3">
                        <a href="https://apps.apple.com/my/app/health-savvy-my/id1616471147" target="_blank">
                            <img src="/static/images/download/appstore_badge.png" style="width: 130px;" />
                        </a>
                    </div>
                </div>
                <p class="mt-3 mb-0 small">* Note: Mobile applications are offered to individuals / employees only.</p>
            </div>
        </div>

        <popup-modal ref="popupRequestVerificationEmail" :hasCloseButton="false" title="Activation Email Sent!">
            <template slot="content">
                <p>An activation email has been sent to your email address, {{ form.emailAddress }}.</p>
                <p>
                    Please click on the confirmation link in the email to activate your new account.
                </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupSuccessful">Okay</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
// import { ErrorBag } from 'vee-validate';
import Cookies from 'js-cookie';
import popupModal from '@/components/popup-modal';
export default {
    'components': {
        popupModal
    },
    'computed': {
        appIsAuthenticated () {
            return !this.$store.state.isPublic;
        },
        sideMenuList () {
            return this.$store.state.app.sideMenuList;
        },
        companyCustomerSupportEmail () {
            return this.$store.state.operator.supportEmailAddress;
        },
        isClinicDoctorOrNurseLogin () {
            return this.radioClinicStaffLogin === 'loginAsDoctorOrNurse';
        },
        isVaccinationCentreLogin () {
            return this.$route.name === 'vaccination-centre-login';
        }
    },
    'watch': {
        sideMenuList (sideMenuList) {
            if (this.appIsAuthenticated) {
                this.goToDefaultPage();
            }
        }
    },
    data () {
        return {
            'form': {
                'emailAddress': null,
                'password': null,
                'username': null
            },
            'isStaffLogin': false,
            'isSubmitting': false,
            'loginError': false,
            'loginErrorMessage': '',
            'loginErrorCritical': false,
            'radioClinicStaffLogin': 'loginAsDoctorOrNurse',
            'userEmailNeedsVerification': false
        };
    },
    beforeMount () {
        if (this.appIsAuthenticated) {
            this.goToDefaultPage();
        } else {
            this.$store.commit('setSideMenuList', []);
        }
    },
    'methods': {
        submitLogin () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.userEmailNeedsVerification = false;
                    this.loginError = false;
                    this.loginErrorMessage = '';

                    let payload = {
                        'e': this.form.emailAddress,
                        'p': this.form.password
                    };

                    if (this.isStaffLogin && this.isClinicDoctorOrNurseLogin) {
                        payload.u = this.form.username;
                    }

                    let url = this.isVaccinationCentreLogin ? 'VaccinationCentre/Login' : 'account/login';

                    this.axios.post(url, payload).then(({
                        data
                    }) => {
                        if (data.data) {
                            // Store token
                            Cookies.set('t', data.data.token);
                            this.axios.defaults.headers.common = { 'Authorization': `bearer ${data.data.token}` };

                            // Setup user session
                            this.setupUserSession(data.data.userSession);
                        }
                    }).catch((error) => {
                        this.loginErrorCritical = true;
                        this.loginError = true;
                        this.$store.commit('clearUserState');
                        this.$store.commit('setAppStatus', true);

                        let responseData = error.response ? error.response.data : null;

                        if (responseData) {
                            if (responseData.code === 9001) {
                                this.userEmailNeedsVerification = true;
                                this.loginErrorCritical = false;
                                this.loginErrorMessage = 'Your email address has not been verified yet. <br>Please click on the confirmation link in the activation email to activate your new account.';
                            } else if (responseData.code === 9090) {
                                this.loginErrorCritical = false;
                                this.loginErrorMessage = 'Your account is still under review. Please check back in a moment.';
                            } else if (responseData.code === 9091) {
                                this.loginErrorCritical = false;
                                this.loginErrorMessage = `Your account is disapproved. Please <a href="mailto:${this.companyCustomerSupportEmail}" target="_blank">contact us</a> if you need any further information.`;
                            } else {
                                this.loginErrorMessage = `Login Failed. ${responseData.message ? responseData.message : null}`;
                            }

                            // if (responseData.c === 9007) {
                            //     if (responseData.d && responseData.d.ve) {
                            //         let errors = responseData.d.ve;

                            //         const bag = new ErrorBag();
                            //         errors.forEach(error => {
                            //             if (error.p === 'e') {
                            //                 bag.add({
                            //                     'field': 'email',
                            //                     'msg': error.e[0]
                            //                 });
                            //             }
                            //         });
                            //         // Display it like this:
                            //         bag.first('email');
                            //     }
                            // }
                        } else {
                            this.loginErrorMessage = 'Login Failed.';
                        }
                    });
                } else {
                    this.$nextTick(() => {
                        let errorDoms = document.querySelectorAll('.is-invalid');

                        if (errorDoms) {
                            errorDoms[0].focus();
                        }
                    });
                }
            });
        },
        setupUserSession (userData) {
            this.$store.commit('setUserDetails', userData);
            this.$store.commit('setAppStatus', false);
            this.$store.commit('updateLoginPromptStatus', false);
        },
        goToDefaultPage () {
            if (this.appIsAuthenticated) {
                let fromPath = null;
                if (this.$route) {
                    if (this.$route.query) {
                        if (this.$route.query.from) {
                            fromPath = this.$route.query.from;
                        }
                    }
                }

                if (fromPath) {
                    window.location = fromPath;
                } else {
                    if (this.sideMenuList.length > 0) {
                        if (this.sideMenuList[0].childs) {
                            this.$nextTick(() => {
                                this.$router.push({
                                    'name': this.sideMenuList[0].childs[0].name
                                });
                            });
                        } else {
                            this.$nextTick(() => {
                                this.$router.push({
                                    'name': this.sideMenuList[0].name
                                });
                            });
                        }
                    }
                }
            }
        },
        requestNewVerificationEmail () {
            let payload = {
                'emailAddress': this.form.emailAddress
            };

            this.axios.post('Account/RequestVerificationEmail', payload).then(() => {
                this.userEmailNeedsVerification = false;
                this.$refs.popupRequestVerificationEmail.show();
            }).catch(() => {

            });
        },
        dismissPopupSuccessful () {
            this.$refs.popupRequestVerificationEmail.hide();
        },
        changeToClinicLogin () {
            this.isStaffLogin = true;
        },
        changeToUserLogin () {
            this.isStaffLogin = false;
        }
    }
};

</script>

<style>
    .hr-label {
        position: relative;
        margin-top: 20px;
        margin-bottom: 20px;
        text-align: center;
        clear: both;
        overflow: hidden;
    }

    .hr-label::before,
    .hr-label::after {
        content: '';
        position: relative;
        width: 50%;
        background-color: rgba(0, 0, 0, 0.2);
        display: inline-block;
        height: 1px;
        vertical-align: middle;
    }

    .hr-label::before {
        right: 0.5em;
        margin-left: -50%;
    }

    .hr-label::after {
        left: 0.5em;
        margin-right: -50%;
    }

    /* .login-page {

        padding: 20px;

        background-color: #f3f3f4;

        min-height: 100vh;

    }

    @media (min-width: 768px) {

        .login-page {
            padding: 60px 0;

        }

    } */

</style>
